export default {
  data () {
    return {
      tabs: [],
      initialTab: 0,
      currentTab: 0
    }
  },
  methods: {
    // 处理 tab 点击事件
    handleTabClick(index) {
      this.currentTab = index;
      // 触发自定义事件，通知父组件 tab 切换
      this.onTabChange();
    }
  }
}


// WEBPACK FOOTER //
// ./src/mixin/tabButton.js